import { useState, Fragment } from 'react'
import { Tooltip, IconButton, Box, Collapse } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import { useSelector } from 'react-redux'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { FormatoFechaIso } from '../../../utils/FormatFecha'
const columns = [
  { id: "1", minWidth: 150, align: "center", label: '#' },
  { id: "2", minWidth: 150, align: "center", label: 'Clave' },
  { id: "3", minWidth: 150, align: "center", label: 'Paquete' },
  { id: "4", minWidth: 150, align: "center", label: 'Proveedor' },
  { id: "5", minWidth: 150, align: "center", label: '' },
]

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
})

const TCircuitos = ({ rows }) => {
  const classes = useStyles()
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Feche Inicio</TableCell>
            <TableCell align="center">Fecha Fin</TableCell>
            <TableCell align="center">Disponibilidad</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.IdPaqueteCircuito}>
              <TableCell align="center">{FormatoFechaIso({date:row.FechaInicio, formato: "dd/MM/yyy HH:MM"})}</TableCell>
              <TableCell align="center">{FormatoFechaIso({date:row.FechaFin, formato: "dd/MM/yyy HH:MM"})}</TableCell>
              <TableCell align="center">{row.Disponibilidad}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const Row = ({ row, index }) => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  return (
    <Fragment>
      <TableRow className={classes.root} hover>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{`${row.ClavePaquete}`}</TableCell>
        <TableCell align="center">
          {row.Nombre}
        </TableCell>
        <TableCell align="center">
          {row.Proveedor?.RazonSocial}
        </TableCell>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
                <TCircuitos rows={row?.lPaqueteCicuito ?? []} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  )
}

export default function TCircuitosVuelo() {

  const classes = useStyles()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const { listaVuelosCircuitos } = useSelector(store => store.vueloProveedor)
  console.log("🚀 ~ TCircuitosVuelo ~ listaVuelosCircuitos:", listaVuelosCircuitos)
  const rows = listaVuelosCircuitos ?? []
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              rows
                .map((row, index) => {
                  return (
                    <Row
                      index={index}
                      key={row.IdPaqueteProveedorTerrestre}
                      row={row}
                    />
                  );
                })
            }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  )
}